import { Language } from '@definitiv-packages/angular-dba-library';

export class ProjectLanguage extends Language {
    /* A */

    public abschliessen:string="";
    public abgeschlossen:string="";
    public alle:string="";
    public Audit:string="";
    public AnzahlElectronicIDs: string = "";
    public AnzahlSafetypoints: string = "";
    public AnzahlSicherungssysteme: string = "";
    public AssetLink:string="";  

    /* B */
    
    //override Bezeichnung:string="";
    public Bemerkung : string="";
    public BitteBegruendungEigeben: string = "";
    public Bild : string = "";

    /* C */

    public calendar:string="";

    /* D */
  
    public debitor:string="";
    public debitoren:string="";
    public debitornr:string="";
    public debitorname:string="";
    public debitorbearbeiten:string="";
    public debitorerstellen:string="";

    /* E */    
    public Erledigen: string = "";
    public Erstellt: string = "";
    public ErstelltAm: string = "";
    /* F */
   
    public folgeterminerstellen:string="";
    public folgetermin:string="";

    /* G */
   
    /* H */

    public Home:string="";
    
    /* K */
  

    /* L */
   
    public Longitude:string="";
    public Latitude:string="";
    public LaufzeitVon:string="";
    public LaufzeitBis:string="";
    public Intervall :string="";

    /* M */
  
    public Monat:string="";

    /* N */

    public Nummer:string="";
   
    /* O */

    public objekt:string="";
    public objekte:string="";
    public objektbezeichnung:string="";
    public objektbearbeiten:string="";
    public objekterstellen:string="";
    public offen:string="";    

    /* P */
   
   
    /* R */

    public roofsafetymanagement:string="";
    public roofarea:string="";
    public roofareabearbeiten:string="";
    public roofareaerstellen:string="";
    public Rhythmus :string ="";

    /* S */
   
    public settings:string="";
    public system:string="";
    public Strasse:string="";
    public safetypoint:string="";
    public safetypointbearbeiten:string="";
    public safetypointerstellen:string="";
    public safetypointsuche:string="";
    public service:string="";
    public serviceerstellen:string="";
    public servicebearbeiten:string="";
    public serviceabschliessen:string="";
    public storniert:string="";
    public Status:string="";
    public Stornieren:string="";
    public Standort: string = "";
    public Standorterstellen: string = "";
    public Standortbearbeiten: string = "";
    public Sicherungssystem: string = "";
    public Sicherungssystemerstellen: string = "";
    public Sicherungssystembearbeiten: string = "";
    public SafetypointNotExist:string="";
    public safetypointshow:string="";
    
    /* T */

    public Telefon:string="";
    public techniker:string="";
    public Tag:string="";
    public Todos:string="";
    public Todo:string="";
    public Termin:string="";
    public TodoStornieren:string="";
   
    /* U */

    /* V */
   
    public Verwaltung:string="";

    /* W */
   
    public Woche:string="";
    public Wochenende:string="";
    
    /* Z */
  
   
}
